window.JJK = window.JJK || {};

JJK.ValidDate = class {
	constructor(vonDatumKleinerAlsBisDatum, nameVonElement, nameBisElement, dateSeparator, fehlerhaftesFormatMeldung, gueltigesStartDatumAb, mindatum) {
		this.VonDatumKleinerAlsBisDatum = vonDatumKleinerAlsBisDatum;
		this.DateSeparator = dateSeparator;
		this.FehlerhaftesFormatMeldung = fehlerhaftesFormatMeldung;
		this.NameVonElement = nameVonElement;
		this.NameBisElement = nameBisElement;
		this.GueltigesStartDatumAb = gueltigesStartDatumAb;
		this.minDatum = mindatum;
		this.getError = jQuery.validator.format('');
	}

	CheckDate(value, element, param) {
		const resultDatum = new Object();

		if (!this.getDate(value, resultDatum)) {
			this.getError.message = this.FehlerhaftesFormatMeldung;
			return false;
		}
		if (this.minDatum !== undefined && resultDatum.value < this.minDatum) {
			this.getError.message = this.GueltigesStartDatumAb;
			return false;
		}

		if (!this.checkDatumVonBis(resultDatum, element)) {
			this.getError.message = this.VonDatumKleinerAlsBisDatum;
			return false;
		}
		return true;
	}

	checkDatumVonBis(resultDatum, element) {
		if (element.id.length >= 3 && element.id.substr(element.id.length - 3, 3) === this.NameBisElement) {
			const vonSelector = `#${element.id.substr(0, element.id.length - 3)}${this.NameVonElement}`;
			const vonControl = $(vonSelector);
			if (vonControl.length !== 0) {
				const vonDatum = new Object();
				if (this.getDate(vonControl.val(), vonDatum)) {
					if (vonDatum.value > resultDatum.value) {
						return false;
					}
				}
			}
		}
		return true;
	}

	getDate(value, result) {
		if (value.match(/^\d\d?.\d\d?.\d\d\d\d$/)) {
			const parts = value.split(this.DateSeparator);
			if (parts[1] > 0 && parts[0] > 0) {
				result.value = new Date(parts[2], parts[1] - 1, parts[0]);
				return true;
			}
		}
		return false;
	}
};
